export default function Footer() {
  return (
    <footer
      data-testid="site-footer"
      className="mt-32"
      style={{ backgroundColor: "hsl(var(--ivory))" }}
    >
      <div className="mx-auto max-w-7xl px-6 sm:px-10 py-12 rule-top flex flex-col sm:flex-row items-start sm:items-center justify-between gap-6">
        <p className="font-serif text-2xl italic text-[hsl(var(--plum-soft))]">
          Simple, foundations-first, quietly effective.
        </p>
        <p className="overline">© {new Date().getFullYear()} Mentorship · Fit</p>
      </div>
    </footer>
  );
}
